import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { GA_MEASUREMENT_ID } from '../data/constants'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * Charge Google Analytics 4 et enregistre chaque changement de page.
 * Ne fait absolument rien tant que GA_MEASUREMENT_ID est vide :
 * aucun script externe, aucun cookie.
 */
export function useAnalytics() {
  const location = useLocation()

  // Chargement du script, une seule fois
  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return
    if (document.getElementById('ga4-script')) return

    const script = document.createElement('script')
    script.id = 'ga4-script'
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer?.push(args)
    }
    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false,
    })
  }, [])

  // Une vue par page visitée
  useEffect(() => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.hash,
      page_title: document.title,
    })
  }, [location.pathname, location.hash])
}
